import { Paper, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import PaymentsIcon from "@mui/icons-material/Payments";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import PaidIcon from "@mui/icons-material/Paid";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { formatCurrency, formatInteger } from "../formatters";
import { BrandDailyRow, BrandMtdRow } from "./brandsApiMapping";

const PRIMARY = "#8E24AA";

interface BrandsKpiCardsProps {
  dailyRows: BrandDailyRow[];
  mtdRows: BrandMtdRow[];
}

export default function BrandsKpiCards({ dailyRows, mtdRows }: BrandsKpiCardsProps) {
  const income = mtdRows.reduce((total, row) => total + row.income, 0);
  const reported = mtdRows.reduce((total, row) => total + row.reported, 0);
  const paid = mtdRows.reduce((total, row) => total + row.paid, 0);
  const qualified = dailyRows.reduce((total, row) => total + row.qualified, 0);
  const epq = reported ? income / reported : 0;
  const epp = paid ? income / paid : 0;

  return (
    <Grid container spacing={2.5}>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper variant="outlined" sx={{ p: "18px 20px", borderColor: "#ececec" }}>
          <Stack direction="row" alignItems="center">
            <Typography variant="caption" fontWeight={600} color={PRIMARY} sx={{ flex: 1 }}>
              TOTAL INCOME
            </Typography>
            <PaymentsIcon sx={{ color: "#2E7D32" }} />
          </Stack>
          <Typography variant="h5" fontWeight={700} sx={{ mt: 1, fontSize: 30, color: "#1a1a1a" }}>
            {formatCurrency(income)}
          </Typography>
          <Typography variant="caption" sx={{ color: "#9e9e9e", fontSize: 12, display: "block", mt: 0.25 }}>
            MTD
          </Typography>
        </Paper>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper variant="outlined" sx={{ p: "18px 20px", borderColor: "#ececec" }}>
          <Stack direction="row" alignItems="center">
            <Typography variant="caption" fontWeight={600} color={PRIMARY} sx={{ flex: 1 }}>
              REPORTED
            </Typography>
            <TaskAltIcon sx={{ color: PRIMARY }} />
          </Stack>
          <Typography variant="h5" fontWeight={700} sx={{ mt: 1, fontSize: 30, color: "#1a1a1a" }}>
            {formatInteger(reported)}
          </Typography>
          <Typography variant="caption" sx={{ color: "#9e9e9e", fontSize: 12, display: "block", mt: 0.25 }}>
            successfully reported
          </Typography>
        </Paper>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper variant="outlined" sx={{ p: "18px 20px", borderColor: "#ececec" }}>
          <Stack direction="row" alignItems="center">
            <Typography variant="caption" fontWeight={600} color={PRIMARY} sx={{ flex: 1 }}>
              PAID LEADS
            </Typography>
            <PaidIcon sx={{ color: PRIMARY }} />
          </Stack>
          <Typography variant="h5" fontWeight={700} sx={{ mt: 1, fontSize: 30, color: "#1a1a1a" }}>
            {formatInteger(paid)}
          </Typography>
          <Typography variant="caption" sx={{ color: "#9e9e9e", fontSize: 12, display: "block", mt: 0.25 }}>
            {formatInteger(qualified)} qualified
          </Typography>
        </Paper>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper variant="outlined" sx={{ p: "18px 20px", borderColor: "#ececec" }}>
          <Stack direction="row" alignItems="center">
            <Typography variant="caption" fontWeight={600} color={PRIMARY} sx={{ flex: 1 }}>
              EPQ
            </Typography>
            <TrendingUpIcon sx={{ color: PRIMARY }} />
          </Stack>
          <Typography variant="h5" fontWeight={700} sx={{ mt: 1, fontSize: 30, color: "#1a1a1a" }}>
            {formatCurrency(epq)}
          </Typography>
          <Typography variant="caption" sx={{ color: "#9e9e9e", fontSize: 12, display: "block", mt: 0.25 }}>
            EPP {formatCurrency(epp)}
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
}
